export default __webpack_public_path__ + "images/21c5d695c8d51ce9124e550c795ffdf7.svg";